import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { CircleAlert } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const BreakingNews = () => {
  const [breakingNews, setBreakingNews] = useState([]);
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    fetchBreakingNews();
  }, []);

  useEffect(() => {
    if (breakingNews.length > 0) {
      const interval = setInterval(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % breakingNews.length);
      }, 5000);

      return () => clearInterval(interval);
    }
  }, [breakingNews]);

  const fetchBreakingNews = async () => {
    try {
      const response = await axios.get(`${API_URL}/api/breaking-news`);
      if (response.data && response.data.length > 0) {
        setBreakingNews(response.data);
      }
    } catch (error) {
      console.error('Failed to fetch breaking news:', error);
    }
  };

  if (breakingNews.length === 0) {
    return null; // Don't show banner if no breaking news
  }

  return (
    <div className="bg-red-600 text-white">
      <div className="container mx-auto px-4">
        <div className="flex items-center py-2">
          <div className="flex items-center space-x-2 mr-4 flex-shrink-0">
            <CircleAlert className="w-4 h-4" />
            <span className="font-bold text-sm uppercase">Breaking News</span>
          </div>
          <div className="flex-1 overflow-hidden">
            <div className="animate-fade-in">
              <span className="text-sm md:text-base">
                {breakingNews[currentIndex].text_bengali || breakingNews[currentIndex].text}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default BreakingNews;